<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Blogs</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <span class="breadcrumb-item active">Blogs</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <router-link :to="`/add-blog`">
                  <button class="btn btn-info">Add New Blog</button>
                </router-link>
              </div>
            </div>
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Is Main Blog</th>
                    <th>Date Added</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(blog, index) in blogs" :key="blog.id">
                    <td>{{blog.id}}</td>
                    <td>{{blog.title}}</td>
                    <td data-toggle="modal" data-target="#exampleModal" @click="activeBlogIndex = index">View Description</td>
                    <td class="checkbox-icon pt-0 disabled-click">
                      <label class="checkbox-container">
                        <input :checked="blog.is_main_blog" type="checkbox">
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td>{{blog.created_at}}</td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteBlog(blog.id)" aria-hidden="true"></i>
                      <router-link :to="`/edit-blog/` + blog.id">
                        <i class="fas fa-pencil-alt fa-icons ml-md-1"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      {{this.blogs[activeBlogIndex].title}}
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    {{this.blogs[activeBlogIndex].description}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Blog from '@/models/Blog'
export default {
  name: 'Blogs',
  data () {
    return {
      activeBlogIndex: 0,
      datatable: null,
      blogs: []
    }
  },
  computed: {
    isLoading () {
      if (this.blogs.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)

    let naturalScript = document.createElement('script')
    naturalScript.setAttribute('src', 'https://cdn.datatables.net/plug-ins/1.10.16/sorting/natural.js')
    document.head.appendChild(naturalScript)
    this.fetchAllBlogs()
  },
  methods: {
    fetchAllBlogs () {
      this.blogs = []
      this.$store.dispatch('fetchAllBlogs')
        .then((result) => {
          result.data.blogs.forEach(blog => {
            this.blogs.push(new Blog(blog))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteBlog (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this blog?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteBlog', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllBlogs()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        pagingType: 'full_numbers',
        'order': [[ 0, 'desc' ]],
        columnDefs: [
          {
            targets: 4,
            'orderable': false
          }
        ],
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Blog/Blogs.vue